query TravelerAvailableTags($id: UUID!) {
  travelerAvailableTags(entityId: $id) {
    nodes {
      id
      name
      badgeName
      badgeColor
    }
  }
}
